import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackActionButtonClick } from './tracking';
import { sendWsAnswer } from '../../actions/wsAnswer';
import { currentOpenChatSelector } from '../../selectors';
import { TActionButtonV2 } from '../../types/actionButtonV2';
import { EActionButtonV3Type, TActionButtonV3 } from '../../types/actionButtonV3';
import {
  doesButtonHaveBookingCalendarSettingsLink,
  doesButtonHaveDailyrentReviewLink,
} from '../../utils/dailyrent/shouldShowDailyrentButtons';
import { useDailyrentModal } from '../../utils/dailyrent/useDailyrentModal';

type TActionButton = TActionButtonV2 | TActionButtonV3;

export const useActionButtonHandler = (
  actionButton: TActionButton,
  messageId: string,
  communicationId: string | undefined,
): ((evt?: React.MouseEvent<HTMLElement>) => void) => {
  const { type, socketPayload, link } = actionButton;

  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const isDailyrentSuccessReviewButton = doesButtonHaveDailyrentReviewLink(actionButton);
  const isDailyrentSetupBookingCalendarButton = doesButtonHaveBookingCalendarSettingsLink(actionButton);

  const currentChat = useSelector(currentOpenChatSelector);
  const { offer, chatId } = currentChat || {};

  const buttonStyle = 'style' in actionButton ? actionButton.style : undefined;
  const buttonName = 'promoName' in actionButton ? actionButton.promoName : actionButton.analyticsName;

  const { openModal } = useDailyrentModal();

  const handleClick = (evt: React.MouseEvent<HTMLElement>) => {
    if (type === EActionButtonV3Type.Socket) {
      dispatch(sendWsAnswer({ messageId, payload: socketPayload as string }));
    } else if (isDailyrentSuccessReviewButton) {
      evt.preventDefault();
      openModal('review');
    } else if (isDailyrentSetupBookingCalendarButton && isDesktop) {
      evt.preventDefault();
      // На десктопе показываем модалку перетока в апки
      openModal('booking');
    }

    trackActionButtonClick(messageId, chatId, buttonName, communicationId, offer, link, buttonStyle);
  };

  return handleClick;
};
